import React, { useEffect, useState } from "react";
import { Button } from "@mui/material";
import "./Certificates.css";
import arrow from "../../images/arrow.svg";
import BulletPointList from "../BulletPointList/BulletPointList";
import {
  fetchMedicalCertificates,
  MedicalCertificate,
} from "src/network/fetchMedicalCertificates";
import { ReactSVG } from "react-svg";
import { useNavigate } from "react-router-dom";

const ToggleItem: React.FC<{
  number: number;
  title: string;
  detailsLink: string;
  children: React.ReactNode;
}> = ({ number, title, children, detailsLink }) => {
  const [expanded, setExpanded] = useState(false);
  const navigate = useNavigate();
  return (
    <div className={`certificate-item ${expanded ? "open" : ""}`}>
      <div
        onClick={() => setExpanded(!expanded)}
        className={`toggle-title ${expanded ? "open" : ""}`}
      >
        <div className="certificate-title-container">
          <div className="certificate-number">{number}</div>
          <span className="certificate-title">{title}</span>
        </div>
        <button className={`certificate-icon-button`}>
          <h4 className="certificate-icon">{expanded ? "-" : "+"} </h4>{" "}
        </button>
      </div>
      <>
        <p className={`certificate-description ${expanded ? "open" : ""}`}>
          {children}
        </p>
        {expanded && (
          <Button
            className="more-buttonn"
            onClick={() => {
              navigate(detailsLink);
            }}
          >
            more
            <ReactSVG src={arrow} />
          </Button>
        )}
      </>
    </div>
  );
};

const Certificates: React.FC = () => {
  const [certificates, setCertificates] = useState<MedicalCertificate[]>([]);

  useEffect(() => {
    const getCertificates = async () => {
      try {
        const certs = await fetchMedicalCertificates();
        setCertificates(certs);
      } catch (error) {
        console.error("Failed to fetch Certificates:", error);
      }
    };

    getCertificates();
  }, []);

  return (
    <section className="certificates-section">
      <div className="certificates">
        <div className="certificates-header">
          <h2 className="certificates-title">dotmedica</h2>
          <h2 className="certificates-subtitle">certificates</h2>
        </div>
        <ul className="certificates-list">
          {certificates.map((cert, index) => (
            <li key={index}>
              <ToggleItem
                number={index + 1}
                title={cert.title}
                detailsLink={cert.details_link}
              >
                <BulletPointList text={cert.list} />
              </ToggleItem>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default Certificates;
